import React, { Component } from 'react';
import { Input, Button,Modal,message } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { ExportFixedLine } from '../AddComment';
import moment from 'moment';

const confirm = Modal.confirm;
class Filter extends Component {
    state = {
        searchParams: {},
        showLeakBtn: false,
        ifShowReFixedBtn:false
    }

    componentDidMount() {
        this.checkoutAuthority();
        this.getDate();
        this.showRerecordFinishPrent();
    }

    checkoutAuthority = () => {
        const options = {
            url: API_URL.sumtotal.checkoutAuthority,
            data: {},
            dataType: 'json',
            doneResult: (res => {
                if (res.data == "1") {
                    this.setState({ showLeakBtn: true });
                }
            })
        };
        $.sendRequest(options);
    }

    search = () => {
        const { siteOptions, searchParams } = this.state;
        const { investigationSiteId } = searchParams;
        if (investigationSiteId) {
            const isExist = siteOptions.some(item => item.value == investigationSiteId);
            if (!isExist) {
                message.warning('请选择正确的中心');
                return;
            }
        }
        this.props.search({...searchParams});
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    export = () => {
        this.props.export();
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    toggleLeak = () => {
        this.props.toggleLeak(true);
    }

    showFixedLine = investigationId => {
        this.exportFixedLineRef.show(investigationId);
    }

    reFixedData = () => {
      
        confirm({
            title: '确认对此项目的完工百分比进行重跑?',
            content:"重跑后的数据将替换本月固化数据",
            onOk: () => {
                const options = {
                    url: API_URL.sumtotal.rerecordFinishPresent,
                    data: {},
                    dataType: 'json',
                    doneResult: (res => {
                        if(res.success){
                           message.success(res.success);
                           this.reRun();
                        }
                    })
                };
                $.sendRequest(options);
            },
        });
    }

    reRun=()=>{
        const { searchParams } = this.state;
        const options = {
           method: 'POST',
           url: API_URL.home.startFinishPresentRerecordTask,
           data: {},
           dataType: 'json',
           doneResult: res => {
                  Modal.success({
                    title: '完工百分比重跑成功',
                    okText:"知道了"
                  });
             this.props.search({...searchParams});    
           }
       }

       $.sendRequest(options); 
   }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
           const nowT = moment(date).format('YYYY-MM-DD HH:mm');
           this.setState({
            nowDate:nowT,
        });
        });
    }

    showRerecordFinishPrent = () => {
        const options = {
            method: 'POST',
            url: API_URL.home.showRerecordFinishPrent,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { isshow } = res;
               this.setState({
                ifShowReFixedBtn:isshow==1,
            });
            }
        }
        $.sendRequest(options);
    }



    render() {
        const { invId, acStatus } = this.props;
        const { showLeakBtn } = this.state;
        const { curRole } = sessionStorage;
        const isBO = curRole == 'BO';
        const isPA = curRole == 'PA';
        const isPM = curRole == 'PM';
        const isVP = curRole == 'VP';
        const isCTA = curRole == 'CTA';
        const isFIN = curRole == 'FIN';
        const isPML = curRole == 'PML';
        const isBA = curRole == 'BA';
        const isBAL = curRole == 'BAL';
        const{nowDate}=this.state;
        const nowDay = moment(nowDate).format('DD');
        //const ifShowReFixedBtn = ((nowDay=="31")||(nowDay=="30"))&&(isBO||isFIN)
        //const ifShowReFixedBtn = true;
        const {ifShowReFixedBtn} = this.state;
        const hash = location.hash.substr(1);
        const PercentInside = hash ==="/sumTotal/percent"
        return (
            <div>
                <div className="search-bar" style={{ marginBottom: 16 }}>
                    <div className="search-item">
                        <label className="ui-label">JDE项目号</label>
                        <Input
                            placeholder='请输入'
                            style={{ width: 110 }}
                            onKeyPress={this.enterSearch}
                            onChange={e => this.handleInputChange(e, 'childCode')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">中心</label>
                        <HighSearchInput
                            name='site'
                            keyword='searchKey'
                            style={{ width: 180 }}
                            params={{ invId }}
                            placeholder="输入中心/编号检索"
                            url={API_URL.site.list}
                            config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'projectPercent' }}
                            onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'investigationSiteId', 'siteOptions')}
                        />
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.export} disabled={this.props.list==0}>导出</Button>
                        {
                            (isBO || isPM || isVP || isCTA || isFIN || isBA || isBAL || isPML) && <Button type="primary" onClick={() => this.showFixedLine(invId)} className="yellow">导出固化数据</Button>
                        }
                        {
                            (isBO || isCTA || isPML) &&
                            (
                                acStatus == 'CLOSE' ?
                                    <Button type="primary" onClick={() => this.props.showAcLog(invId,'OPEN')} className="yellow">开启AC</Button>
                                :
                                    <Button type="primary" onClick={() => this.props.showAcLog(invId,'CLOSE')} className="yellow">关闭AC</Button>
                            )
                        }
                        {
                            (isBO || isCTA || isPM || isPML) &&
                            <Button
                                type="primary"
                                className="yellow"
                                onClick={this.props.showTransfiniteModal}
                            >{(isPM || isPML) ? '超限申请' : '设置超限阀值'}</Button>
                        }
                        {
                            (showLeakBtn && !isPA) &&
                            <Button type="primary" onClick={this.toggleLeak} >补录数据</Button>
                        }
                        {
                            ifShowReFixedBtn && PercentInside &&
                            <Button type="primary"  style={{ marginLeft: 8, background: '#62cf96', border: '1px solid #00a854' }} 
                             onClick={this.reFixedData} >重跑固化数据</Button>
                        }
                    </div>
                </div>
                <ExportFixedLine ref={el => this.exportFixedLineRef = el} />
            </div>
        );
    }
}
export default Filter;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/Filter.js